import { render, staticRenderFns } from "./StoryList.vue?vue&type=template&id=0a9780d9&scoped=true&"
import script from "./StoryList.vue?vue&type=script&lang=js&"
export * from "./StoryList.vue?vue&type=script&lang=js&"
import style0 from "./StoryList.vue?vue&type=style&index=0&id=0a9780d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9780d9",
  null
  
)

export default component.exports